import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// we want to check line numbers (in test builds)
// so keep this file small
import React from 'react';
import log from 'uix/logging';
import { useDispatch, useRouter, useActions, useSelector } from 'uix/hooks';
// ---Local imports
import { triggerSagaError } from '../actions';
// ---Exports
export const TestErrorDuringRender = ({})=>{
    let dispatch = useDispatch();
    let { request, go } = useRouter();
    let [callApi, reduceApi] = useActions([
        'callApi',
        'reduceApi'
    ]);
    let _triggerSagaError = useActions(triggerSagaError);
    let session = useSelector((root)=>root.meta.user.session);
    if (request.query.triggerRenderError) {
        throw Error('something bad happened');
    }
    if (request.query.logExceptionInRender) {
        try {
            throw Error('something bad happened');
        } catch (e) {
            log.exception('something bad', e);
        }
    }
    let Trigger = ({ s, f })=>/*#__PURE__*/ _jsx("div", {
            children: /*#__PURE__*/ _jsx("input", {
                style: {
                    width: 160
                },
                type: "button",
                onClick: f,
                value: s
            })
        });
    let logException = ()=>{
        try {
            UNDECLARED;
        } catch (e) {
            log.exception('logged exception: %o %O', 'why?', e);
        }
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Trigger, {
                s: "filter error",
                f: ()=>go({
                        query: {
                            triggerFilterError: true
                        }
                    })
            }),
            /*#__PURE__*/ _jsx(Trigger, {
                s: "render error",
                f: ()=>go({
                        query: {
                            triggerRenderError: true
                        }
                    })
            }),
            /*#__PURE__*/ _jsx(Trigger, {
                s: "saga error",
                f: ()=>_triggerSagaError()
            }),
            /*#__PURE__*/ _jsx(Trigger, {
                s: "reducer error",
                f: ()=>dispatch({
                        type: 'TEST_ERROR_THROW'
                    })
            }),
            /*#__PURE__*/ _jsx(Trigger, {
                s: "reducer mutation",
                f: ()=>dispatch({
                        type: 'TEST_ERROR_MUTATE'
                    })
            }),
            /*#__PURE__*/ _jsx(Trigger, {
                s: "log exception (click)",
                f: logException
            }),
            /*#__PURE__*/ _jsx(Trigger, {
                s: "log exception (render)",
                f: ()=>go({
                        query: {
                            logExceptionInRender: true
                        }
                    })
            }),
            /*#__PURE__*/ _jsx(Trigger, {
                s: "delete session",
                f: ()=>callApi('deleteSession', {
                        id: session
                    })
            })
        ]
    });
};
